import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { BUSINESS } from "../lib/site";
import { HoursTable } from "./HoursTable";
import { MapCard } from "./MapCard";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="grain bg-charcoal text-cream pt-16 pb-8 relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        {/* Bandeau haut : marque + téléphone */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 pb-12 border-b border-white/10">
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-4">
              <img
                src={BUSINESS.logo}
                alt="Logo Au Fournil de Pierre"
                className="h-16 w-16 object-contain bg-cream rounded-full p-1"
              />
              <div>
                <p className="font-serif text-3xl leading-none">Au Fournil de Pierre</p>
                <p className="kicker text-crust mt-2">Boulangerie artisanale · Nantes</p>
              </div>
            </div>
            <p className="text-white/60 text-sm max-w-md leading-relaxed">
              Pain au levain naturel, baguettes de tradition et viennoiseries
              cuites chaque matin, au cœur du quartier des Lilas.
            </p>
            <a
              href={BUSINESS.phoneLink}
              data-testid="footer-phone"
              className="inline-flex items-center gap-3 font-serif text-3xl sm:text-4xl text-cream hover:text-crust transition-colors duration-300 w-fit"
            >
              <Phone size={26} className="text-crust" />
              {BUSINESS.phoneDisplay}
            </a>
            <a
              href={BUSINESS.emailLink}
              data-testid="footer-email"
              className="inline-flex items-center gap-3 text-lg text-white/70 hover:text-crust transition-colors duration-300 w-fit break-all"
            >
              <Mail size={20} className="text-crust shrink-0" />
              {BUSINESS.emailDisplay}
            </a>
          </div>

          {/* Horaires */}
          <div>
            <p className="kicker text-crust mb-6">Horaires d'ouverture</p>
            <HoursTable tone="dark" testId="footer-hours" />
          </div>
        </div>

        {/* Carte + itinéraire */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 py-12">
          <div>
            <p className="kicker text-crust mb-6">Nous trouver</p>
            <MapCard testId="footer-map" height="h-80" />
          </div>
          <div className="flex flex-col justify-center gap-4">
            <h2 className="font-serif text-4xl sm:text-5xl leading-tight">
              Passez nous voir.<br />Le café est prêt.
            </h2>
            <p className="text-white/60 text-sm max-w-sm leading-relaxed">
              Une question, une commande, un grand format pour une tablée ?
              Appelez-nous ou écrivez-nous, nous répondons avec plaisir.
            </p>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="kicker text-cream border-b border-crust pb-1 w-fit hover:text-crust transition-colors duration-300"
            >
              Nous contacter →
            </Link>
          </div>
        </div>

        {/* Bas de page */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} Au Fournil de Pierre — {BUSINESS.addressLine}
          </p>
          <div className="flex gap-6">
            <Link to="/produits" className="text-white/40 text-xs hover:text-crust transition-colors">
              Produits
            </Link>
            <Link to="/contact" className="text-white/40 text-xs hover:text-crust transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
